import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { CENTERSTAGE_COPY as COPY } from './centerstageCopy';
import type { CenterstageStyles } from './centerstageStyles';

export interface CenterstageFilterChip {
  key: string;
  label: string;
  onRemove: () => void;
}

export interface CenterstageFilterChipsProps {
  styles: CenterstageStyles;
  chips: readonly CenterstageFilterChip[];
  /** Clears every filter and the search term; without it there is no "Show all videos". */
  onShowAll?: () => void;
  /** The clear-all wording; "Show all videos" by default. */
  showAllLabel?: string;
}

/** One removable chip per active filter, then "Show all videos" when `onShowAll` is given. Renders nothing when no filter is active. */
export function CenterstageFilterChips({ styles, chips, onShowAll, showAllLabel }: CenterstageFilterChipsProps) {
  if (chips.length === 0) return null;
  return (
    <div role="group" aria-label={COPY.chipRowLabel} style={styles.chipRow}>
      {chips.map((chip) => (
        <span key={chip.key} style={styles.chip}>
          {chip.label}
          <button type="button" aria-label={COPY.removeFilter(chip.label)} onClick={chip.onRemove} style={styles.chipRemove}>
            <FontAwesomeIcon icon={faXmark} aria-hidden="true" style={{ fontSize: '12px' }} />
          </button>
        </span>
      ))}
      {onShowAll ? <button type="button" onClick={onShowAll} style={styles.showAll}>{showAllLabel ?? COPY.showAll}</button> : null}
    </div>
  );
}
